import React, { useContext, useState, useEffect } from 'react'
import HeaderHomeUsers from '../../../components.js/users/homeUsers/HeaderHomeUsers'
import { AppContext } from '../../../App'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import Spinner from '../../../components.js/elements/Spinner'
import useHomeUsers from '../../../hooks/users/useHomeUsers'
import useHomeUsersPlanning from '../../../hooks/users/useHomeUsersPlanning'
import useFirebase from '../../../firebase/useFirebase'
import BookingToCome from './../../../components.js/users/homeUsers/BookingToCome'
import HomeUserButton from '../../../components.js/users/homeUsers/HomeUserButton'
import ModalConfirm from './../../../components.js/modal/ModalConfirm'
 
const INITIAL_STATE = {  
    idService:'', 
    nameService:'',
    priceService:'',
    durationService:'',
    idStaff:'',
    surnameStaff:'',
    nameStaff:'',
    surname:'',
    name:'',
    email:'',
    password:'',
    hours:'',
}

const HomeUsers = () => { 
    const { user } = useContext(AppContext) 
    const [montage, setMontage] = useState(false) 
    const { valuesService } = useHomeUsers(INITIAL_STATE)
    const { _converteTimeToHours } = useHomeUsersPlanning(valuesService)
    const { updateData, readData, readDataMessagesChat, profil, booking, count, messagesChat, clients } = useFirebase()
    const { keyUid, tokenUser } = useParams()
    let navigate = useNavigate()
    const [idResetBooking, setIdResetBooking] = useState()

    // ExponentPushToken[I88p4GCSIKKuXlYNBP7sQE]
    // https://naughty-rosalind-cbf8d6.netlify.app/homeUser/Z1NJJ5CuMoP28U12gxqQoR5NkvG2/I88p4GCSIKKuXlYNBP7sQE
    // https://localhost:3000/homeUser/Z1NJJ5CuMoP28U12gxqQoR5NkvG2/I88p4GCSIKKuXlYNBP7sQE

    useEffect(() => {
        window.scrollTo(0, 0)
        localStorage.setItem('keyUid', keyUid) 
        localStorage.setItem('tokenUser', tokenUser)
        setMontage(false)
        console.log('HomeUsers useEffect ',tokenUser)
    },[count])

    useEffect(() => {
        readData(keyUid) 
        readDataMessagesChat(keyUid) 
        _writeToken()
    },[montage])

    if (montage) return <Spinner />

    if (user?.uid === keyUid) {
        navigate('/homeServeur')
    }

    // ENREGISTRER LE TOKEN DANS LA DATABASE
    const _writeToken = () => {
        const data = {[tokenUser]:tokenUser}
        updateData('entreprises/'+keyUid+'/tokens', data) 
    }

    const _deleteBooking = () => {
        const data = {cancel:true}
        updateData('entreprises/'+keyUid+'/booking/'+idResetBooking,data)
        setIdResetBooking()
    }

    return (
        <div className='container-fluid'>

            {keyUid && 
                <>
            {/* ENTETE AVEC ICON LOGIN */}
            <HeaderHomeUsers  
                profil={profil} 
                keyUid={keyUid}
                user={user}
                clients={clients}
            />  

            {/* AJOUTER UN LOGO ET NOM D'ENTREPRISE */}
            <div className='text-center'>ici ajouter le logo ou le nom de l'entreprise</div>

            {/* RESERVATION A VENIR */}
            <BookingToCome
                user={user}
                booking={booking}
                _converteTimeToHours={_converteTimeToHours}
                setIdResetBooking={setIdResetBooking}
            />  

            {/* NOUVELLE PARTIE */}
            <HomeUserButton
                keyUid={keyUid} 
                profil={profil}
                messagesChat={messagesChat}
            />

            {/* MODAL CONFIRM */}
            <ModalConfirm
                _handleModal={_deleteBooking}
                title='Êtes-vous sûr de vouloir supprimer le RDV'
            />

            <div style={{ height:600 }}/>
            </>}
        </div>
    )
}

export default HomeUsers


